import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import en from '../../../international/translations/en';
import CancelWrapper from '../CancelWrapper/CancelWrapper';
import performRedirect from '../../../utils/performRedirect';
import { showCancellationProgress } from '../../../redux/Cancel/subscription';

class CancelThanks extends Component {
  componentDidMount() {
    this.props.showCancellationProgress(4);
    if (window.analytics) {
      window.analytics.page('Cancel Funnel', 'Redirect');
    }
    window.setTimeout(() => {
      performRedirect();
    }, 5000);
  }

  render() {
    return (
      <CancelWrapper>
        <div className="cancel-thanks">
          <Helmet title={en.cancellation_funnel.meta_title_thanks} />
          <h1 className="cancel-thanks__title">{en.cancellation_funnel.title_thanks}</h1>
          <p className="cancel-thanks__message" dangerouslySetInnerHTML={{ __html: en.cancellation_funnel.thanks_message_redirect }} />
        </div>
      </CancelWrapper>
    );
  }
}

export default connect(() => null, { showCancellationProgress })(CancelThanks);
